import CTA from "../Constants";

export function setChatsLoading(isLoading) {
    return {
        type: CTA.SET_CHATS_LOADER,
        payload: { isLoading },
    };
}
export function setLoaderAction(val, loaderHash) {
    return {
        type: CTA.SET_LOADER,
        payload: {
            isLoading: val,
            loaderHash: loaderHash,
        },
    };
}

export function setAuthAction(isAuth, agent) {
    return {
        type: CTA.SET_AUTH,
        payload: {
            isAuthenticated: isAuth,
            agent: agent,
        },
    };
}

export function setAgentAction(agent) {
    return {
        type: CTA.SET_AGENT,
        payload: {
            agent: agent,
        },
    };
}

export function setChatsListAction(chats) {
    return {
        type: CTA.SET_CHATS,
        payload: {
            chats: chats,
        },
    };
}

export function setChatsListFiltersAction(chatsListFilters) {
    return {
        type: CTA.SET_CHATS_LIST_FILTERS,
        payload: {
            chatsListFilters: chatsListFilters,
        },
    };
}

export function setSelectedChatAction(selectedChat) {
    return {
        type: CTA.SET_SELECTED_CHAT,
        payload: {
            selectedChat: selectedChat,
        },
    };
}

export function setSelectedChatHistoryAction(selectedChatHistory) {
    return {
        type: CTA.SET_SELECTED_CHAT_HISTORY,
        payload: {
            selectedChatHistory: selectedChatHistory,
        },
    };
}

export function setChatOwnerAction(chat, owner) {
    return {
        type: CTA.SET_CHAT_OWNER,
        payload: {
            chat: chat,
            owner: owner,
        },
    };
}

export function setClosedChatAction(chat) {
    return {
        type: CTA.SET_CLOSED_CHAT,
        payload: {
            chat: chat,
        },
    };
}
export function updateChatAction(chat) {
    return {
        type: CTA.UPDATE_CHAT,
        payload: {
            chat: chat,
        },
    };
}

export function updateChatSeenAction(chat) {
    return {
        type: CTA.UPDATE_CHAT_SEEN,
        payload: {
            chat: chat,
        },
    };
}

export function addOrUpdateChatAction(chat) {
    return {
        type: CTA.ADD_OR_UPDATE_CHAT,
        payload: {
            chat: chat,
        },
    };
}

export function updateCustomerInfoAction(chat, customer) {
    return {
        type: CTA.UPDATE_CUSTOMER_INFO,
        payload: {
            chat: chat,
            customer: customer,
        },
    };
}

export function setLikedAnswerAction(answer) {
    return {
        type: CTA.SET_LIKED_ANSWER,
        payload: {
            answer: answer,
        },
    };
}

export function setNewChatNotificationAction(newChats) {
    return {
        type: CTA.SET_NEW_CHAT_NOTIFICATION,
        payload: {
            newChats: newChats,
        },
    };
}

export function setChatOwnerButtonAction(clicked) {
    return {
        type: CTA.SET_CHAT_OWNER_BUTTON,
        payload: {
            chatOwnerButton: clicked,
        },
    };
}

export function setCurrentChatOptionAction(id, selected) {
    return {
        type: CTA.SET_CURRENT_CHAT_OPTION,
        payload: {
            chatSelectedId: id,
            currentChatOption: selected,
        },
    };
}

export function setWorkspaceConfigAction(config) {
    return {
        type: CTA.SET_WORKSPACE_CONFIG,
        payload: {
            workspaceConfig: config,
        },
    };
}

export function setConversationLabelsAction(conversationLabels) {
    return {
        type: CTA.SET_CONVERSATION_LABELS,
        payload: {
            conversationLabels: conversationLabels,
        },
    };
}

export function setConversationTagGroups(groups) {
    return {
        type: CTA.SET_CONVERSATION_TAG_GROUPS,
        payload: {
            conversationTagGroups: groups,
        },
    };
}

export function setChatSocketStatusAction(chatSocketStatus) {
    return {
        type: CTA.SET_CHAT_SOCKET_STATUS,
        payload: {
            chatSocketStatus: chatSocketStatus,
        },
    };
}

export function setNotificationSocketStatusAction(notificationSocketStatus) {
    return {
        type: CTA.SET_NOTIFICATION_SOCKET_STATUS,
        payload: {
            notificationSocketStatus: notificationSocketStatus,
        },
    };
}

export function markChatRead(chat) {
    return {
        type: CTA.MARK_READ,
        payload: {
            chat: chat,
        },
    };
}

export function markChatUnread(chat) {
    return {
        type: CTA.MARK_UNREAD,
        payload: {
            chat: chat,
        },
    };
}

export function setWorkspaceName(workspaceName) {
    return {
        type: CTA.SET_WORKSPACE_NAME,
        payload: {
            workspaceName: workspaceName,
        },
    };
}

export function setAgentState(agentState) {
    return {
        type: CTA.SET_AGENT_STATE,
        payload: {
            agentState: agentState,
        },
    };
}

/**
 * @param {boolean} found
 * @param {number | undefined} chatId
 * @returns
 */
export function setDeepLinkChatState(found, chatId) {
    return {
        type: CTA.SET_DEEP_LINK_CHAT_STATE,
        payload: {
            deepLinkChatState: {
                found,
                chatId,
            },
        },
    };
}
